/** Platform label for ShiftyPM super-admin sessions (not a tenant company). */
export const SHIFTY_PLATFORM_LABEL = 'ShiftyPM';

/**
 * Which company or platform this session is operating under.
 * @param {{ role?: string, companyId?: string } | null | undefined} userData
 * @param {{ name?: string } | null | undefined} workspace
 * @returns {string}
 */
export function resolveTenantContextLabel(userData, workspace) {
  if (userData?.role === 'super_admin') {
    return SHIFTY_PLATFORM_LABEL;
  }
  const name = typeof workspace?.name === 'string' ? workspace.name.trim() : '';
  if (name) return name;
  const id = typeof userData?.companyId === 'string' ? userData.companyId.trim() : '';
  if (id) return id;
  return SHIFTY_PLATFORM_LABEL;
}

/**
 * Secondary line when company name and Firestore id differ (e.g. show id under name).
 * @param {{ role?: string, companyId?: string } | null | undefined} userData
 * @param {{ name?: string } | null | undefined} workspace
 * @returns {string | null}
 */
export function resolveTenantContextDetail(userData, workspace) {
  if (userData?.role === 'super_admin') return null;
  const id = typeof userData?.companyId === 'string' ? userData.companyId.trim() : '';
  const name = typeof workspace?.name === 'string' ? workspace.name.trim() : '';
  if (name && id && name !== id) return id;
  return null;
}
